<template>
  <el-tag
    :type="tagColor.type"
    :disable-transitions="true"
    :class="tagColor.className"
    effect="plain"
    >{{ title }}</el-tag
  >
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'StateTag',
  data() {
    return {};
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    dictType: {
      type: String,
    },
    label: {
      type: String,
    },
  },
  computed: {
    ...mapGetters(['dictMap']),
    tagColor() {
      let type;
      let className;
      switch (this.value) {
        case '2':
          type = 'danger';
          break;
        case '1':
          type = 'success';
          break;
        case '0':
          type = 'warning';
          break;
        case 'DRAFT':
          className = 'grey';
          break;
        case 'PUBLISHED':
          className = 'success';
          break;
        case 'PUBLISH_CANCELED':
          className = 'orange';
          break;
        case 'PUBLISHE_WAIT':
          className = 'primary';
          break;
        default:
          type = '';
          break;
      }
      return {
        type,
        className,
      };
    },
    title() {
      if (this.label) {
        return this.label;
      } else {
        let name = '未知';
        if (this.dictType) {
          const list = this.dictMap[this.dictType] || [];
          list.forEach((item) => {
            if (item.value === this.value) {
              name = item.name;
            }
          });
        }
        return name;
      }
    },
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.success {
  border: 1px solid #ccf2e5;
  font-size: 12px;
  color: #00bf7f;
}
.grey {
  border: 1px solid #e9e9ea;
  font-size: 12px;
  color: #909399;
}
.orange {
  border: 1px solid #feebd6;
  font-size: 12px;
  color: #fb9d30;
}
.primary {
  border: 1px solid #f1e4ca;
  font-size: 12px;
  color: #2f70ff;
}
</style>
